/**
 * File Picker Demo Page
 * Test page for file picker functionality
 */

import React from "react";
import { FilePickerDemo } from "@/features/file-picker/demo/FilePickerDemo";

const FilePickerDemoPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-bg-primary dark:bg-bg-primary">
      <FilePickerDemo />
    </div>
  );
};

export default FilePickerDemoPage;
